export enum ORDER_STATUS {
  ARRIVED,
  READING,
  SUBMITTED,
  APPROVED,
  CANCEL,
  COMPLETED,
  NEW,
}

export const ORDER_MATCH_STATUS = {
  UNMATCH: false,
  MATCH: true,
};
